import { AbstractControl, ValidatorFn } from '@angular/forms';

export function whatsapp(): ValidatorFn {
    const nameRe: RegExp = new RegExp(/^\+[\d]+$/i);
    return (control: AbstractControl): { [key: string]: any } | null =>
        (control.value && !nameRe.test(control.value) && { whatsapp: true }) || null;
}
